export default "__VITE_ASSET__n7w320rP__"